import { render, staticRenderFns } from "./Unread.vue?vue&type=template&id=205e28fa&scoped=true&"
import script from "./Unread.vue?vue&type=script&lang=js&"
export * from "./Unread.vue?vue&type=script&lang=js&"
import style0 from "./Unread.vue?vue&type=style&index=0&id=205e28fa&lang=scss&scoped=true&"
import style1 from "./Unread.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205e28fa",
  null
  
)

export default component.exports